import(/* webpackMode: "eager" */ "/var/www/restroagent/src/app/forgot-password/page.tsx");
